import React, { useRef } from "react";
import { createDndContext, DndProvider } from "react-dnd";
import Backend from "react-dnd-html5-backend";
import { GambitTableProps, SortableGambitProps } from "../types";
import SelectableGambit from "./SelectableGambit";
import useSortable from "./useSortable";

const SortableGambit = ({
  order,
  actions,
  ...otherProps
}: SortableGambitProps) => {
  const { swapItems, ...otherActions } = actions;
  const { ref } = useSortable({ order, swapItems });
  return (
    <div ref={ref}>
      <SelectableGambit {...otherProps} actions={otherActions} />
    </div>
  );
};

const DndContext = createDndContext(Backend);

export default function GambitTable({ gambitData, actions }: GambitTableProps) {
  const managerRef = useRef(DndContext);
  return (
    <DndProvider backend={Backend} manager={managerRef.current.dragDropManager}>
      <div className="gambit-table">
        {gambitData.map((gambitEntry, order) => (
          <SortableGambit
            key={gambitEntry.id}
            actions={actions}
            gambit={gambitEntry}
            order={order}
          />
        ))}
      </div>
    </DndProvider>
  );
}
